export const BW_PRODUCTION = 'production'
export const BW_TESTING = 'testing'
export const BW_DEVELOPMENT = 'development'

export const DEFAULT_RESUBMIT_TIME = 500
